import { NgModule } from '@angular/core';
import { AboutRoomWindowComponent } from '@app/pages/main/components/user-profile-details/room-about/about-room-window.component';
import { ModalModule } from '@app/shared/dialogs/modal/modal.module';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { SpinnerModule } from '@app/shared/ui/simple-components/spinner/spinner.module';
import { AboutRoomViewerComponent } from './about-room-viewer.component';
import { EditorModule } from '@app/pages/main/pages/quality/components/shared/editor/editor.module';

@NgModule({
  imports: [CommonModule, ModalModule, ButtonsModule, SpinnerModule, EditorModule],
  exports: [AboutRoomViewerComponent, AboutRoomWindowComponent],
  declarations: [AboutRoomViewerComponent, AboutRoomWindowComponent],
})
export class AboutRoomModule {}
